import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=13330ba3&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=13330ba3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13330ba3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13330ba3')) {
      api.createRecord('13330ba3', component.options)
    } else {
      api.reload('13330ba3', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=13330ba3&scoped=true&", function () {
      api.rerender('13330ba3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4KSx5UDvVm1hX/JS/comp/SearchFilterTokens.vue"
export default component.exports